import React, {useState} from 'react';
import moment from "moment";
import {useForm} from "react-hook-form";
import {Helmet} from "react-helmet";
import {Portlet, PortletHeader, PortletHeaderToolbar} from "../../../../components/Portlet";
import CreateCategoryForm from "../../components/createCategoryForm";
import CustomDatePicker from "../../../base/components/forms/customDatePicker";
import LoadingButton from "../../../base/components/loadingButton";
import axios from "../../../../helpers/axios";
import {Tab, Tabs} from "react-bootstrap";
import {Table} from "reactstrap";
import numberFormat from "../../../../helpers/numberFormat";
import _ from "lodash"
import GlobalReportsRow from "../../components/globalReportsRow";

const GlobalReport = () => {
  const [ loading, setLoading ] = useState(false)
  const [ data, setData] = useState()
  const [tabIndex, setTabIndex] = useState("consumptionOffice");
  const defaultVal= {
    start: moment().subtract(7, 'days').format('DD.MM.YYYY'),
    end: moment().format('DD.MM.YYYY'),
  }
  const formController = useForm({defaultValues:defaultVal})
  const {handleSubmit} = formController

  const submit = (dataS) =>{
    setLoading(true)
    axios.post('/api/fromOneC/globalReport', dataS)
      .then(({data})=>{
        console.log('data', data)
        setData(data.report)
      })
      .finally(()=>setLoading(false))
  }
  const consumptionOffice = data && _.sumBy(data.consumptionOffice, (item) => {
    return _.sumBy(item.data, 'total')
  })

  const income = data && _.sumBy(data.income, (item) => {
    return _.sumBy(item.data, (i) => {
      return i.krs1C + i.krsKayar1C + i.krsSite
    })
  })


  const consumptionCounterparties = data && _.sumBy(data.consumptionCounterparties, 'total')
  const undefTrans = data && _.find(data.consumptionCounterparties, {name:'Проблемные'})?.total
  return (
    <>
      <Helmet><title>Большой отчет</title></Helmet>
      <Portlet>
        <PortletHeader title={"Большой отчет"} toolbar={<PortletHeaderToolbar>
          <form onSubmit={handleSubmit(submit)} className={'d-flex gap-2'}>
            <CustomDatePicker formController={formController}
                              label={"Дата c"}
                              value={defaultVal.start}
                              name={`start`}
                              rules={{required: true}}/>
            <CustomDatePicker formController={formController}
                              label={"Дата по"}
                              value={defaultVal.end}
                              name={`end`}
                              rules={{required: true}}/>
            <LoadingButton loading={loading} title={'Получить'}/>
          </form>
        </PortletHeaderToolbar>}/>
        { data && <>
          <div className={'p-4'}>
            <div className={'text-center mb-2'}>
              <h3>Итого: <b>{numberFormat(consumptionOffice+income)}</b></h3>
              <div>С неопознаными тратами:<b>{numberFormat(consumptionOffice + income +undefTrans)}</b></div>
            </div>
            <div className={'d-flex align-items-center justify-content-between'}>
              <div>Итого трат по офису: <b>{numberFormat(consumptionOffice)}</b>
              </div>
              <div>
                Итого расходов: <b>{numberFormat(consumptionCounterparties)}</b>
              </div>
              <div>
                Итого доход: <b>{numberFormat(income)}</b>
              </div>
            </div>
          </div>

          <Tabs
            variant="underline"
            id="controlled-tab-example"
            activeKey={tabIndex}
            className={'ml-2'}
            onSelect={key => {
              setTabIndex(key)
            }}
          >
            <Tab eventKey="consumptionOffice" title="Траты по офису">
              <Table bordered size={'sm'}>
                <thead>
                <tr>
                  <td>Лист</td>
                  <td>Дата</td>
                  <td>Контрагент</td>
                  <td>Сумма</td>
                  <td>Коммент</td>
                </tr>
                </thead>
                <tbody>
                {data.consumptionOffice.map((row, index) => {
                  const renderItems = (items) => items.map((item, i) => (
                    <tr key={i}>
                      <td>{item.list}</td>
                      <td>{item.issueDate}</td>
                      <td>{item.counterparty}</td>
                      <td>{numberFormat(item.total)}</td>
                      <td>{item.comment}</td>
                    </tr>
                  ))
                  const tableBody = row.children?.length
                    ? row.children.map((child, childIndex) => (
                      <GlobalReportsRow
                        key={childIndex}
                        backgroundColor="#e8f0f7"
                        secondaryRows={renderItems(child.data)}
                      >
                        <th colSpan={3} style={{paddingLeft: 24}}>{child.name}</th>
                        <th colSpan={2}>{numberFormat(child.total)}</th>
                      </GlobalReportsRow>
                    ))
                    : renderItems(row.data)
                  return <React.Fragment key={index}>
                    <GlobalReportsRow
                      secondaryRows={tableBody}>
                      <th colSpan={3}>{row.name}</th>
                      <th colSpan={2}>{numberFormat(_.sumBy(row.data, 'total'))}</th>
                    </GlobalReportsRow>
                  </React.Fragment>
                })}
                </tbody>
              </Table>
            </Tab>
            <Tab eventKey="consumptionCounterparties" title="Расход" >
              <Table bordered size={'sm'}>
                <thead>
                <tr>
                  <td>Дата</td>
                  <td>Контрагент</td>
                  <td>Крс 1с</td>
                  <td>КРС Каяр 1с</td>
                  <td>КРС Сайт</td>
                  <td>НДС</td>
                  <td>Закуп</td>
                  <td>Коммент</td>
                </tr>
                </thead>
                <tbody>
                {data.consumptionCounterparties.map((row,index)=>{
                  const tableBody = row.data.map((item, i)=>{
                    if(row.name === "Нет закупа") {
                      return <tr key={i}>
                        <td>{item.issueDate}</td>
                        <td>{item.counterparty}</td>
                        <td>{numberFormat(item.krs1C)}</td>
                        <td>{numberFormat(item.krsKayar1C)}</td>
                        <td>{numberFormat(item.krsSite)}</td>
                        <td>{numberFormat(item.nds)}</td>
                        <td>{numberFormat(item.total)}</td>
                        <td>{item.comment}</td>
                      </tr>
                    } else {
                      return <tr key={i}>
                        <td>{item.issueDate}</td>
                        <td colSpan={5}>{item.counterparty}</td>
                        <td>{numberFormat(item.total)}</td>
                        <td>{item.comment}</td>
                      </tr>
                    }

                  })
                  return <React.Fragment key={index}>
                    <GlobalReportsRow secondaryRows={tableBody}>
                      <th colSpan={6}>{row.name}</th>
                      <th colSpan={2}>{numberFormat(_.sumBy(row.data, 'total'))}</th>
                    </GlobalReportsRow>
                  </React.Fragment>
                })}
                </tbody>
              </Table>
            </Tab>
            <Tab eventKey="income" title="Доход" >
              <Table bordered size={'sm'}>
                <thead>
                <tr>
                  <td>Дата</td>
                  <td>Контрагент</td>
                  <td>Крс 1с</td>
                  <td>КРС Каяр 1с</td>
                  <td>КРС Сайт</td>
                  <td>НДС</td>
                  <td>Итого</td>
                </tr>
                </thead>
                <tbody>
                {data.income.map((row,index)=>{
                  const tableBody = row.data.map((item, i) => {
                    return <tr key={i}>
                      <td>{item.issueDate}</td>
                      <td>{item.counterparty}{item.comment && ` - ${item.comment}`}</td>
                      <td>{numberFormat(item.krs1C)}</td>
                      <td>{numberFormat(item.krsKayar1C)}</td>
                      <td>{numberFormat(item.krsSite)}</td>
                      <td>{numberFormat(item.nds)}</td>
                      <td>{numberFormat(item.krs1C+item.krsKayar1C+item.krsSite)}</td>
                    </tr>
                  })
                  return <React.Fragment key={index}>
                    <GlobalReportsRow secondaryRows={tableBody}>
                      <th colSpan={2}>{row.name}</th>
                      <th>{numberFormat(_.sumBy(row.data, 'krs1C'))}</th>
                      <th>{numberFormat(_.sumBy(row.data, 'krsKayar1C'))}</th>
                      <th>{numberFormat(_.sumBy(row.data, 'krsSite'))}</th>
                      <th>{numberFormat(_.sumBy(row.data, 'nds'))}</th>
                      <th colSpan={2}>{numberFormat(_.sumBy(row.data, (i) => {
                        return i.krs1C + i.krsKayar1C + i.krsSite
                      }))}</th>
                    </GlobalReportsRow>
                  </React.Fragment>
                })}
                </tbody>
              </Table>
            </Tab>
          </Tabs>
        </>
        }
      </Portlet>
    </>
  );
};

export default GlobalReport;
